module.exports = __webpack_public_path__ + "img/icon-nav6_blue.7d2aa23e.svg";